import axios from "axios";
import { configs } from "../../../assets/Config";

// get all notification functions
export function getNotificationFunctions(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/notificationmanagement/allNotificationSettings`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// update function send type
export function updateNotificationFunctionDetail(token, notificationId, value, type) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "notification_id": notificationId,
                "value": value,
                "type": type
            }
            var config = {
                method: 'patch',
                url: `${process.env.REACT_APP_BASEURL}/admin/notificationmanagement/updateNotificationSetting`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp broadcast category list
export function getBroadcastCategory(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/broadcast/categoryList`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// send whatsapp broadcast
export function sendWhatsappBroadcast(token, broadcastCategory, template_name, head_variable, body_variable, utm, company_id, company_name, user_filters, portfolio_size, quantity, price, send_to_esop_holders) {
    return new Promise(async (resolve, reject) => {
        try {
            var data = {
                "broadcast": broadcastCategory,
                "template_name": template_name,
                "head_variable": head_variable,
                "body_variable": body_variable,
                "utm": utm,
                "company_id": company_id ?? "",
                "company_name": company_name ?? "",
                "user_filters": user_filters ?? [],
                "portfolio_size": portfolio_size ?? "",
                "quantity": quantity ?? "",
                "price": price ?? "",
                "send_to_esop_holders": !!send_to_esop_holders
            }
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/broadcast/whatsapp`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp broadcast history
export function getWhatsappBroadcastHistory(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/broadcast/whatsapp`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp broadcast history detail
export function getWhatsappBroadcastHistoryDetail(token, broadcastId) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/broadcast/whatsapp/${broadcastId}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp response messages
export function getWhatsappMessages(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/data`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// update message response status
export function updateMessageResponseStatus(token, messageId) {
    return new Promise(async (resolve, reject) => {
        try {
            let data = JSON.stringify({
                id: messageId
            })
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/markAsResponded`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// update message comment
export function updateMessageComment(token, messageId, comment) {
    return new Promise(async (resolve, reject) => {
        try {
            let data = JSON.stringify({
                id: messageId,
                comment: comment
            })
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/comment`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: data
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp contacts
export function getWhatsappContacts(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/contact`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// get whatsapp message by contact
export function getWhatsappContactMessages(token, mobile) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/message/${mobile}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}


// send whatsapp message to contact
export function sendWhatsappContactMessages(token, name, mobile, message) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/message`,
                headers: {
                    'Authorization': `Bearer ${token}`,

                },
                data: JSON.stringify({
                    phone_number: mobile,
                    message: message.trim(),
                    name: name
                })
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}


// mark whatsapp message as read
export function markWhatsappMessageReadByContact(token, mobile) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/whatsapp/message/read`,
                headers: {
                    'Authorization': `Bearer ${token}`,

                },
                data: JSON.stringify({
                    phone_number: mobile
                })
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// send all user communication
export function sendAllUserCommunication(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/notificationmanagement/all-user-comm`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// schedule email broadcast
export function scheduleEmailBroadcast(token, user_filters, mail_type, company_id, portfolio_size, start_date, end_date, frequency, quantity, price, send_to_esop_holders) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/scheduler/create`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }, data: {
                    "user_filters": user_filters,
                    "mail_type": mail_type,
                    "company_id": company_id,
                    "portfolio_size": portfolio_size,
                    "start_date": start_date,
                    "end_date": end_date,
                    "frequency": frequency,
                    "quantity": quantity,
                    "price": price,
                    "send_to_esop_holders": !!send_to_esop_holders,
                    "scheduler_type": "EMAIL_BROADCAST"

                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}
// send email broadcast
export function sendEmailBroadcast(token, user_filters, mail_type, company_id, portfolio_size, start_date, end_date, frequency, quantity, price, send_to_esop_holders) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/broadcast/email`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }, data: {
                    "user_filters": user_filters,
                    "mail_type": mail_type,
                    "company_id": company_id,
                    "portfolio_size": portfolio_size,
                    "start_date": start_date,
                    "end_date": end_date,
                    "frequency": frequency,
                    "quantity": quantity,
                    "price": price,
                    "send_to_espo_holders": !!send_to_esop_holders,
                    "scheduler_type": "EMAIL_BROADCAST"

                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// schedule email broadcast
export function getScheduleEmailBroadcast(token, jobType, jobId) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/scheduler/get/${jobId ? jobId : "email_broadcast"}${jobType ? `?status=${jobType}` : ""}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// scheduler update template
export function schedulerUpdateTemplate(token, updateData) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/scheduler/update-template`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: updateData
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}

// delete job by id
export function deleteScheduledJobById(token, jobId) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'delete',
                url: `${process.env.REACT_APP_BASEURL}/admin/scheduler/${jobId}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}